import prepareSegmentSliderApiUrl from '@stencil/hotels-utils/src/prepare-segment-slider-api-url';
import {AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';

import {AppState} from '../../../../verticals/hotels-dweb/src/shared/store';
import {
  errorLoadingSegmentSliderAction,
  toggleLoadingSegmentSliderAction,
  updateSegmentSliderAction,
} from './actions';
import {ICommonStoreState} from './types';
// import { fetchHelper } from '../../../utils/fetchHelper';
import Megatron from '@stencil/megatron';

export const fetchSegmentSliderDataThunk = (
  vcid = '',
  hctx = '',
  key = 'common',
): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(toggleLoadingSegmentSliderAction(true));

    const {srp, common} = getState();
    const {destination, checkin, checkout, roomString, country} = common;
    const {srpConfig, srpData} = srp;
    const {filter, segmentSliderHctxIndex} = srpConfig;
    const url = prepareSegmentSliderApiUrl({
      checkin,
      checkout,
      roomString,
      cityId: vcid,
      hctx,
    });

    Megatron({
      name: 'segment slider api',
      type: 'GET',
      url,
    })
      .then(response => {
        dispatch(
          updateSegmentSliderAction({
            [key]: response,
          } as ICommonStoreState['segmentSliderApi']['data']),
        );
        dispatch(toggleLoadingSegmentSliderAction(false));
      })
      .catch(err => {
        console.trace(err);
        dispatch(errorLoadingSegmentSliderAction(true));
      });
  };
};
